// src/components/container.ts
import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";
var baseStyle = defineStyle({
  w: "100%",
  mx: "auto",
  maxW: "prose",
  px: "4"
});
var containerTheme = defineStyleConfig({
  baseStyle
});

export {
  containerTheme
};
//# sourceMappingURL=chunk-TECE6HDR.mjs.map